import BasicImage from '@home/components/BasicImage';
import React from 'react';
import GameDefault from '@/pages/home/assets/img/common/game-default.svg';
import SvgIcon from '@home/components/SvgIcon';
import classNames from 'classnames';
import CommonBubble from '@home/components/CommonBubble';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';
import './getRender.scss';
import { getColor } from '@home/pages/studio/studioAssessment/components/StudioAssessnebtTableCard/getRender';

export const getGameHeader = (item: any) => {
  const { img, name, version, isLatest, latestText, className, desc } = item;
  return (
    <div
      className={classNames(className, 'dbd-benchmark-gtdr-table-game-header')}
    >
      <div className="dbd-benchmark-gtdr-table-game-header-img">
        <BasicImage src={img || ''} alt="" errorSrc={GameDefault} />
      </div>
      <div className="dbd-benchmark-gtdr-table-game-header-name">
        <CommonBubble content={desc && <FormatHtmlTextToReact text={desc} />}>{name}</CommonBubble>
      </div>
      {version && (
        <div className="dbd-benchmark-gtdr-table-game-header-version">
          {version}
          {isLatest && (
            <span className="dbd-benchmark-gtdr-table-game-header-version-latest">
              {latestText}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export const getGameScoreDom = (
  value: string,
  item: any,
  colorList: string[],
  descKey: string,
  isDark: boolean,
  benchmarkConfig: any,
) => {
  let img;
  const { [descKey]: desc } = item || {};
  const { benchmarkLow = '3', benchmarkMid = '6' } = benchmarkConfig || {};
  const bgColor = getColor(value, colorList, benchmarkLow, benchmarkMid);

  if (Number(value) >= 9) {
    img = (
      <i style={isDark ? { filter: 'invert(100%)' } : undefined}>
        <SvgIcon type="zan" style={{ color: '#fff' }} />
      </i>
    );
  }

  return (
    <div
      className="dbd-benchmark-gtdr-table-content-td-div dbd-benchmark-gtdr-table-content-td-score"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      {(bgColor) && (
        <div
          style={{
            background: bgColor,
            position: 'absolute',
            top: 4,
            left: 4,
            right: 4,
            bottom: 4,
            borderRadius: 6,
            zIndex: 0,
            ...((bgColor && isDark) ? { filter: 'invert(100%)' } : {}),
          }}
        />
      )}
      <div style={{ position: 'relative', zIndex: 1 }}>
        <CommonBubble style={{ maxWidth: '516px' }} content={desc && <FormatHtmlTextToReact text={desc} />}>
          <span
            style={{
              ...(value ? {color: '#fff'} : {}),
              ...(bgColor && isDark ? { filter: 'invert(100%)' } : {}),
            }}
          >
            {value || '-'}
          </span>
          {img}
        </CommonBubble>
      </div>
    </div>
  );
};
